import * as widgetActions from '../Widget/actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const eventMappings = {};
eventMappings[widgetActions.ON_BACK_FROM_REP_ACTION] = [trackCancelAction];

export function trackActionInit(state, activeAction){
	apiTracking.trackActionInit({
		...state,
		widget: {
			...state.widget,
			activeAction
		}
	});
}

function trackCancelAction(state) {
    const actionCancelTime = state.widget.cancelTime;

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCancelTime: actionCancelTime
    });

    apiTracking.trackCancelAction(state, actionCancelTime);
}
